
(function () {
  function init() {
    var sections = document.querySelectorAll('[id*="section_dynamic_cats"]');
    if (!sections.length) return;

    sections.forEach(function (sec) {
      var panels = sec.querySelectorAll('.group-block');
      var imgs = sec.querySelectorAll('.group-block__media-wrapper img');
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if ('IntersectionObserver' in window && !reduceMotion) {
        var obs = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              obs.unobserve(entry.target);
            }
          });
        }, { threshold: 0.15, rootMargin: '0px 0px -5% 0px' });
        panels.forEach(function (p) { obs.observe(p); });
      } else {
        panels.forEach(function (p) { p.classList.add('is-visible'); });
      }

      if (reduceMotion || !imgs.length) return;

      var ticking = false;
      function applyParallax() {
        var rect = sec.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var progress = (vh - rect.top) / (vh + rect.height);
        progress = Math.max(0, Math.min(1, progress));
        var shift = (progress - 0.5) * 44;
        imgs.forEach(function (img, i) {
          var depth = (i % 2 === 0) ? 1 : 1.5;
          img.style.transform = 'translateY(' + (shift * depth).toFixed(1) + 'px) scale(1.12)';
        });
        ticking = false;
      }
      function onScroll() {
        if (!ticking) {
          window.requestAnimationFrame(applyParallax);
          ticking = true;
        }
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      applyParallax();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
